import { Repository } from "src/firebase/firestore/repository";
import { WordBankItem } from "../types/ai-session.entity";

class WordBankRepository extends Repository<WordBankItem> {
  constructor() {
    super("word_bank");
  }

  async findById(id: string): Promise<WordBankItem | null> {
    return (await super.findById(id)) as WordBankItem | null;
  }
}

export const wordBankRepository = new WordBankRepository();
